import axios from "axios";
import ServiceException from "@/models/ServiceException";
import Brand from "@/models/Brand";

const baseURL = `${process.env.VUE_APP_API_URL}/api/brands`;

export default {
  async getBrand(id) {
    if (!id) return null;
    const response = await axios.get(`${baseURL}/${id}`);
    if (response?.data?.responseCode !== 200) {
      throw new ServiceException(response?.data);
    }
    return response.data.result;
  },
  async getBrands() {
    const response = await axios.get(`${baseURL}`);
    if (response?.data?.responseCode !== 200) {
      throw new ServiceException(response?.data);
    }
    return response.data.result;
  },

  async updateBrand(brand) {
    if (!(brand instanceof Brand)) {
      throw new ServiceException({
        responseCode: 400,
        responseMessage: "Bad request",
      });
    }
    const response = await axios.put(`${baseURL}/${brand.id}`, brand);
    if (response?.data?.responseCode !== 200) {
      throw new ServiceException(response?.data);
    }
    return response.data.result;
  },

  async createBrand(brand) {
    if (!(brand instanceof Brand)) {
      throw new ServiceException({
        responseCode: 400,
        responseMessage: "Bad request",
      });
    }
    const response = await axios.post(`${baseURL}`, brand);
    if (response?.data?.responseCode !== 200) {
      throw new ServiceException(response?.data);
    }
    return response.data.result;
  },
};
